export default __webpack_public_path__ + "static/media/USSF-Primary.41e27a2b.png";